import React from 'react';

interface ChevronDownIconProps {
  className?: string;
  strokeWidth?: number | string;
  /**
   * `stroked` (default) is the 24x24 Lucide-parity chevron. `hairline` is the
   * marketing design system's 20x20 chevron at a 1.6 stroke, the disclosure
   * indicator on the redesigned FAQ rows.
   */
  variant?: 'stroked' | 'hairline';
}

export function ChevronDownIcon({
  className = 'h-4 w-4',
  strokeWidth = 2,
  variant = 'stroked',
}: ChevronDownIconProps): React.ReactElement {
  if (variant === 'hairline') {
    return (
      <svg
        className={className}
        fill="none"
        viewBox="0 0 20 20"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M5 7.5l5 5 5-5" />
      </svg>
    );
  }
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      aria-hidden="true"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}
